"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRegionInfo = getRegionInfo;
Object.defineProperty(exports, "RegionItem", {
  enumerable: true,
  get: function get() {
    return _types.RegionItem;
  }
});
Object.defineProperty(exports, "Region", {
  enumerable: true,
  get: function get() {
    return _types.Region;
  }
});
Object.defineProperty(exports, "Platform", {
  enumerable: true,
  get: function get() {
    return _types.Platform;
  }
});
Object.defineProperty(exports, "constants", {
  enumerable: true,
  get: function get() {
    return _constants.constants;
  }
});
Object.defineProperty(exports, "generateEzbuyDomain", {
  enumerable: true,
  get: function get() {
    return _generateDomain.generateEzbuyDomain;
  }
});
Object.defineProperty(exports, "generateBlazerDomain", {
  enumerable: true,
  get: function get() {
    return _generateDomain.generateBlazerDomain;
  }
});
Object.defineProperty(exports, "generateLITBDomain", {
  enumerable: true,
  get: function get() {
    return _generateDomain.generateLITBDomain;
  }
});
Object.defineProperty(exports, "EzbuyApp", {
  enumerable: true,
  get: function get() {
    return _ezbuy.EzbuyApp;
  }
});
Object.defineProperty(exports, "ezbuyDomains", {
  enumerable: true,
  get: function get() {
    return _domainRegex.ezbuyDomains;
  }
});
Object.defineProperty(exports, "blazerDomains", {
  enumerable: true,
  get: function get() {
    return _domainRegex.blazerDomains;
  }
});
Object.defineProperty(exports, "sunflowerDomains", {
  enumerable: true,
  get: function get() {
    return _domainRegex.sunflowerDomains;
  }
});
Object.defineProperty(exports, "litbDomains", {
  enumerable: true,
  get: function get() {
    return _domainRegex.litbDomains;
  }
});
Object.defineProperty(exports, "getEzbuyInfoFromHost", {
  enumerable: true,
  get: function get() {
    return _domainRegex.getEzbuyInfoFromHost;
  }
});
Object.defineProperty(exports, "getSunflowerInfoFromHost", {
  enumerable: true,
  get: function get() {
    return _domainRegex.getSunflowerInfoFromHost;
  }
});
Object.defineProperty(exports, "DomainInfo", {
  enumerable: true,
  get: function get() {
    return _domainRegex.DomainInfo;
  }
});
Object.defineProperty(exports, "LOCAL_DOMAIN", {
  enumerable: true,
  get: function get() {
    return _domainRegex.LOCAL_DOMAIN;
  }
});
Object.defineProperty(exports, "LOCAL_DOMAIN_REGEXP", {
  enumerable: true,
  get: function get() {
    return _domainRegex.LOCAL_DOMAIN_REGEXP;
  }
});
Object.defineProperty(exports, "isLocalDevelop", {
  enumerable: true,
  get: function get() {
    return _domainRegex.isLocalDevelop;
  }
});
Object.defineProperty(exports, "UAT_DOMAIN", {
  enumerable: true,
  get: function get() {
    return _domainRegex.UAT_DOMAIN;
  }
});
Object.defineProperty(exports, "isUatDevelop", {
  enumerable: true,
  get: function get() {
    return _domainRegex.isUatDevelop;
  }
});
Object.defineProperty(exports, "isLocalOrUatDevelop", {
  enumerable: true,
  get: function get() {
    return _domainRegex.isLocalOrUatDevelop;
  }
});
Object.defineProperty(exports, "is65emallNetDomain", {
  enumerable: true,
  get: function get() {
    return _domainRegex.is65emallNetDomain;
  }
});
Object.defineProperty(exports, "isEzbuyDevDomain", {
  enumerable: true,
  get: function get() {
    return _domainRegex.isEzbuyDevDomain;
  }
});
Object.defineProperty(exports, "is65emallCnDomain", {
  enumerable: true,
  get: function get() {
    return _domainRegex.is65emallCnDomain;
  }
});
Object.defineProperty(exports, "userAgentRegExp", {
  enumerable: true,
  get: function get() {
    return _regex.userAgentRegExp;
  }
});
Object.defineProperty(exports, "iosRegExp", {
  enumerable: true,
  get: function get() {
    return _regex.iosRegExp;
  }
});
Object.defineProperty(exports, "userAgentMobileRegExp", {
  enumerable: true,
  get: function get() {
    return _regex.userAgentMobileRegExp;
  }
});
Object.defineProperty(exports, "ezbuyDevDomainRegExp", {
  enumerable: true,
  get: function get() {
    return _regex.ezbuyDevDomainRegExp;
  }
});
Object.defineProperty(exports, "emallNetDomainRegExp", {
  enumerable: true,
  get: function get() {
    return _regex.emallNetDomainRegExp;
  }
});
Object.defineProperty(exports, "emallCnDomainRegExp", {
  enumerable: true,
  get: function get() {
    return _regex.emallCnDomainRegExp;
  }
});
Object.defineProperty(exports, "tboxMeDomainRegExp", {
  enumerable: true,
  get: function get() {
    return _regex.tboxMeDomainRegExp;
  }
});
Object.defineProperty(exports, "allLettersRegExp", {
  enumerable: true,
  get: function get() {
    return _regex.allLettersRegExp;
  }
});
Object.defineProperty(exports, "enRegExp", {
  enumerable: true,
  get: function get() {
    return _regex.enRegExp;
  }
});
Object.defineProperty(exports, "hasBlankRegExp", {
  enumerable: true,
  get: function get() {
    return _regex.hasBlankRegExp;
  }
});
Object.defineProperty(exports, "litbSystemRegExp", {
  enumerable: true,
  get: function get() {
    return _regex.litbSystemRegExp;
  }
});
Object.defineProperty(exports, "litbAdorSystemRegExp", {
  enumerable: true,
  get: function get() {
    return _regex.litbAdorSystemRegExp;
  }
});
Object.defineProperty(exports, "ezbuySystemRegExp", {
  enumerable: true,
  get: function get() {
    return _regex.ezbuySystemRegExp;
  }
});
Object.defineProperty(exports, "excelTypeRegExp", {
  enumerable: true,
  get: function get() {
    return _regex.excelTypeRegExp;
  }
});
Object.defineProperty(exports, "noneRegExp", {
  enumerable: true,
  get: function get() {
    return _regex.noneRegExp;
  }
});
Object.defineProperty(exports, "numRegExp", {
  enumerable: true,
  get: function get() {
    return _regex.numRegExp;
  }
});
Object.defineProperty(exports, "commaRegExp", {
  enumerable: true,
  get: function get() {
    return _regex.commaRegExp;
  }
});
Object.defineProperty(exports, "numEndRegExp", {
  enumerable: true,
  get: function get() {
    return _regex.numEndRegExp;
  }
});
Object.defineProperty(exports, "numStartRegExp", {
  enumerable: true,
  get: function get() {
    return _regex.numStartRegExp;
  }
});
Object.defineProperty(exports, "onlyNumLertterHanziRegExp", {
  enumerable: true,
  get: function get() {
    return _regex.onlyNumLertterHanziRegExp;
  }
});
Object.defineProperty(exports, "questionMarkRegExp", {
  enumerable: true,
  get: function get() {
    return _regex.questionMarkRegExp;
  }
});
Object.defineProperty(exports, "isMoblieClient", {
  enumerable: true,
  get: function get() {
    return _commonRegex.isMoblieClient;
  }
});
Object.defineProperty(exports, "isIOS", {
  enumerable: true,
  get: function get() {
    return _commonRegex.isIOS;
  }
});
Object.defineProperty(exports, "isAndroid", {
  enumerable: true,
  get: function get() {
    return _commonRegex.isAndroid;
  }
});
Object.defineProperty(exports, "isAllLetters", {
  enumerable: true,
  get: function get() {
    return _commonRegex.isAllLetters;
  }
});
Object.defineProperty(exports, "isEn", {
  enumerable: true,
  get: function get() {
    return _commonRegex.isEn;
  }
});
Object.defineProperty(exports, "isHasBlank", {
  enumerable: true,
  get: function get() {
    return _commonRegex.isHasBlank;
  }
});
Object.defineProperty(exports, "isLitbSystem", {
  enumerable: true,
  get: function get() {
    return _commonRegex.isLitbSystem;
  }
});
Object.defineProperty(exports, "isExcelFile", {
  enumerable: true,
  get: function get() {
    return _commonRegex.isExcelFile;
  }
});
Object.defineProperty(exports, "limitTwoDecimals", {
  enumerable: true,
  get: function get() {
    return _commonRegex.limitTwoDecimals;
  }
});
Object.defineProperty(exports, "limitInteger", {
  enumerable: true,
  get: function get() {
    return _commonRegex.limitInteger;
  }
});
Object.defineProperty(exports, "urlIsLITB", {
  enumerable: true,
  get: function get() {
    return _commonRegex.urlIsLITB;
  }
});
Object.defineProperty(exports, "isNone", {
  enumerable: true,
  get: function get() {
    return _commonRegex.isNone;
  }
});
Object.defineProperty(exports, "isAllNum", {
  enumerable: true,
  get: function get() {
    return _commonRegex.isAllNum;
  }
});
Object.defineProperty(exports, "linkJudgeBegin", {
  enumerable: true,
  get: function get() {
    return _commonRegex.linkJudgeBegin;
  }
});
exports.SiteInfo = exports.SunflowerApp = void 0;

var _types = require("./types");

var _constants = require("./constants");

var _generateDomain = require("./generateDomain");

var _ezbuy = require("./appUtils/ezbuy");

var _SunflowerApp = _interopRequireWildcard(require("./appUtils/sunflower"));

exports.SunflowerApp = _SunflowerApp;

var _domainRegex = require("./domainRegex");

var _regex = require("./regex");

var _commonRegex = require("./commonRegex");

var _SiteInfo = _interopRequireWildcard(require("./siteInfo"));

exports.SiteInfo = _SiteInfo;

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function getRegionInfo(region) {
  return _constants.constants.find(function (v) {
    return v.regionCode === region;
  }) || {};
}